import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import {CheckPermission} from 'modules/login/CheckPermission';

export default class RowItemParameter extends React.Component {

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          {this.props.item.ten}
        </td>
        <td style={{width: '300px', wordBreak: 'break-all'}}>
          {this.props.item.giaTri}
        </td>
        <td>
          {this.props.item.moTa}
        </td>
        <td>
          <div className="todo-wrap two-item">
            {
              CheckPermission('THAMSO_SUA') ?
                <Link
                  className="itt-edit"
                  onClick={this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)}
                  >
                  Chỉnh sửa
                </Link>
              : null
            }
            {
              CheckPermission('THAMSO_XOA') ?
                <DeleteDialog
                  title= {'Xoá danh mục'}
                  content= {'Bạn chắc chắn muốn xoá danh mục này?'}
                  redux={this.props.parent}
                  deleteId = {this.props.item.thamSoId}
                />
              : null
            }
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemParameter.jsx